import { apiClient, buildQuery } from '~/api/client'
import type { AdminFeedback, FeedbackSummary } from '~/api/types'

// 사용자 피드백 읽기 API. 각 서비스의 "피드백" 탭에서 요약·목록을 소비한다.

export interface ListFeedbackParams {
    q?: string
    limit?: number
    offset?: number
}

/** GET /admin/api/services/{service}/feedback — 피드백 목록(페이지네이션). */
export function listFeedback(service: string, params: ListFeedbackParams = {}) {
    const query = buildQuery({
        q: params.q,
        limit: params.limit,
        offset: params.offset,
    })
    return apiClient.get<AdminFeedback[]>(
        `/services/${service}/feedback${query}`
    )
}

/** GET /admin/api/services/{service}/feedback/summary — 피드백 집계. */
export function getFeedbackSummary(service: string) {
    return apiClient.get<FeedbackSummary>(
        `/services/${service}/feedback/summary`
    )
}
